import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import "draft-js/dist/Draft.css";
import ImageUpload from "./ImageUpload";
import VideoUpload from "./VideoUpload";
import axios from "axios";
import { EditorState, convertToRaw, ContentState, convertFromHTML } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";

const EditTaskModel = ({
  editTaskData,
  show,
  setShow,
  w_id,
  v_id,
  setSubtask,
  setSubTaskData,
  setShowEditTask,
  showEditTask,
}) => {
  const [headingText, setHeadingText] = useState(null);
  const [headingTextError, setDescription] = useState("");
  const [workflowId, setWorkFlowId] = useState();
  const [versionId, setVersionId] = useState();
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [selectedVideos, setSelectedVideos] = useState([]);
  const [selectedImages, setSelectedImages] = useState([]);

  const { token } = userData;
  var { apiBaseUrl } = configData.config;

  const onEditorStateChange = (newEditorState) => {
    setEditorState(newEditorState);
  };

  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const handleCreateTask = (isVisible) => {
    setShow(isVisible);
  };

  const closeModal = () => {
    setShow(false);
  };

  const handleSubTask = () => {
    setShow(false);
    setSubtask(true);
    setSubTaskData();
  };
  const handleInputChange = (e) => {
    setHeadingText(e.target.value);
  };
  console.log("22222222222222222222222222222222222222222222222222",editTaskData)
  const Submit_task = async (e) => {
    e.preventDefault();

    try {
      const data = {
        task_id:editTaskData._id,
        workflow_id: workflowId,
        heading_text: headingText,
        version_id: versionId,
        description: draftToHtml(convertToRaw(editorState.getCurrentContent())),
        image_collection: selectedImages,
        video_collection: selectedVideos,
      };

      const response = await axios.post(`${apiBaseUrl}/api/workflow/updatetask`, data, {
        headers,
      });
      if (response.status === 200) {
        console.log("Task created successfully");
      } else {
        console.error("Unexpected response status:", response.status);
      }
    } catch (error) {

      console.error("Error creating task:", error.message);
    }
  };
  useEffect(() => {
    console.log("w_id w_id ")
    console.log(w_id)
    setWorkFlowId(w_id);
    setVersionId(v_id);
  }, [w_id, v_id]);

  const setFieldVlaue = () => {
    setSelectedImages(editTaskData.image_collection || []);
    setSelectedVideos(editTaskData.video_collection || []);
    setHeadingText(editTaskData.heading_text);

    try {
      console.log(editTaskData);
      console.log(
        EditorState.createWithContent(
          ContentState.createFromBlockArray(convertFromHTML(editTaskData.description))
        )
      );
      setEditorState(
        EditorState.createWithContent(
          ContentState.createFromBlockArray(convertFromHTML(editTaskData.description))
        )
      );
    } catch (error) {
      console.log(error);
    }
  };



  useEffect(() => {
    setFieldVlaue();
  }, [showEditTask]);



  return (
    <Modal centered show={showEditTask} size="lg" onHide={() => setShowEditTask(false)}>
      <Modal.Header className="popupheader">
        <span>Edit Task</span>
        <div style={{ cursor: "pointer" }} onClick={() => setShowEditTask(false)}>
          X
        </div>
      </Modal.Header>

      <Modal.Body>

        <div className="pb-2">
          <input
            type="text"
            className="form-control"
            name="heading_text"
            value={headingText}
            onChange={(e) => handleInputChange(e)}
            placeholder="Write Task Title..."
            style={{ marginBottom: "15px" }}
            maxLength="50"
            autoFocus={headingText}
          />
          <p style={{ color: "red", marginTop: "-15px", marginBottom: "5px" }}>
            {headingTextError}
          </p>
        </div>

        <div style={{ border: "1px solid #ccc", padding: "8px" }}>
          <Editor
            editorStyle={{ borderTop: "1px solid #ccc", maxHeight: "100px", minHeight: "100px" }}
            name="project_about"
            id="exampleFormControlDescription"
            stripPastedStyles={true}
            wrapperClassName="demo-wrapper"
            className="mt-2"
            editorClassName="demo-editor"
            editorState={editorState}
            onEditorStateChange={onEditorStateChange}
            toolbar={{
              options: ["inline", "remove", "history"],
              inline: {
                inDropdown: false,
                options: ["bold", "italic", "underline", "strikethrough"],
              },
            }}
          />
        </div>

        <div>
          <ImageUpload
            workflowId={workflowId}
            selectedImages={selectedImages}
            setSelectedImages={setSelectedImages}
          />
        </div>

        <div>
          <VideoUpload selectedVideos={selectedVideos} setSelectedVideos={setSelectedVideos}  workflowId={workflowId} />
        </div>

        {/* <button className="btn btn-sm btn-danger" onClick={handleSubTask}>
          Edit SubTask
        </button> */}

        <div className="d-flex flex-row-reverse mb-2 mt-3">
          <button className="btn btn-sm btn-danger" onClick={Submit_task}>
            Update
          </button>
        </div>

      </Modal.Body>
    </Modal>
  );
};

export default EditTaskModel;
